import React, { useState } from 'react';
import PropTypes from 'prop-types';

// TODO: use debounce instead of throttle?
import { throttle } from 'throttle-debounce';

import AutocompleteField from '../AutocompleteField';

import { fetchSkillResults } from './api';

import './SkillField.less';

export function SkillField({ input, onChange, onSelect, skills }) {
  const [items, setItems] = useState([]);
  const [value, setValue] = useState('');
  const throttleDelay = 500;

  const getItemValue = (item) => item;

  const getSkillResults = throttle(throttleDelay, async (newValue) => {
    setItems(newValue ? await fetchSkillResults(newValue) : []);
  });

  const handleChange = (event) => {
    const { value: newValue } = event.target;

    onChange(newValue);
    setValue(newValue);
    getSkillResults(newValue);
  };

  const handleSelect = (newValue) => {
    if (newValue && !skills.find((skill) => skill.name === newValue)) {
      const newSkills = [...skills, { name: newValue }];

      if (onSelect(newSkills)) {
        // reset input field
        setItems([]);
        setValue('');
      }
    }
  };

  const handleManualEntry = () => handleSelect(value.trim());

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleManualEntry();
    }
  };

  return (
    <div className="skill_field">
      <AutocompleteField
        getItemValue={getItemValue}
        items={items}
        renderItem={(item, isHighlighted) => (
          <div className={`item ${isHighlighted ? 'item_highlighted' : ''}`} key={item}>
            {item}
          </div>
        )}
        autoHighlight={false}
        onChange={handleChange}
        onSelect={handleSelect}
        renderMenu={(menuItems) => <div className="menu">{menuItems}</div>}
        // override id if passed one in
        inputProps={{ id: 'LabeledField_Skill', ...input, onKeyPress: handleKeyPress }}
        value={value}
        wrapperStyle={{}}
      />
      <button type="button" className="add_btn" onClick={handleManualEntry}>Add</button>
    </div>
  );
}

SkillField.propTypes = {
  /**
   * Connects your input component to Redux whose props are destructured into
   * your `<input/>` component.
  */
  input: PropTypes.shape({
    autoFocus: PropTypes.bool,
    placeholder: PropTypes.string,
  }).isRequired,

  onChange: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  skills: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default SkillField;
